import { Badge, Card, Group, Stack, Text } from '@mantine/core'
import type { MaintenanceLogWithRelations } from '@markku/types'
import { formatEuros } from '@markku/utils'

interface CostSummaryCardProps {
  log: MaintenanceLogWithRelations
}

export function CostSummaryCard({ log }: CostSummaryCardProps) {
  // Only show if there's any cost data
  if (!log.actualCost && !log.maintenanceTask?.estimatedCost) {
    return null
  }

  const actual = log.actualCost ? parseFloat(log.actualCost) : 0
  const estimated = log.maintenanceTask?.estimatedCost
    ? parseFloat(log.maintenanceTask.estimatedCost)
    : 0
  const variance = estimated > 0 ? actual - estimated : 0

  return (
    <Card withBorder radius="lg" p="md">
      <Stack gap="md">
        <Text fw={600} size="sm">
          Kustannustiedot
        </Text>

        {actual > 0 && (
          <Group justify="space-between">
            <Text size="sm" c="dimmed">
              Toteutunut kustannus
            </Text>
            <Text size="lg" fw={700}>
              {formatEuros(actual)}
            </Text>
          </Group>
        )}

        {estimated > 0 && (
          <Group justify="space-between">
            <Text size="sm" c="dimmed">
              Arvio
            </Text>
            <Group gap="xs">
              <Text
                size="sm"
                c="dimmed"
                td={actual > 0 ? 'line-through' : undefined}
              >
                {formatEuros(estimated)}
              </Text>
              {variance !== 0 && actual > 0 && (
                <Badge color={variance > 0 ? 'red' : 'green'} size="sm">
                  {variance > 0 ? '+' : ''}
                  {formatEuros(variance)}
                </Badge>
              )}
            </Group>
          </Group>
        )}
      </Stack>
    </Card>
  )
}
